export const fastrouterModels = {
    id: "fastrouter",
    name: "FastRouter",
    api: "https://go.fastrouter.ai/api/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://fastrouter.ai/models",
    env: ["FASTROUTER_API_KEY"],
    models: {
        "deepseek-ai/deepseek-r1-distill-llama-70b": {
            id: "deepseek-ai/deepseek-r1-distill-llama-70b",
            name: "DeepSeek R1 Distill Llama 70B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2025-01-23",
            last_updated: "2025-01-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.03,
                output: 0.14,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "anthropic/claude-sonnet-4": {
            id: "anthropic/claude-sonnet-4",
            name: "Claude Sonnet 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
        "anthropic/claude-opus-4.1": {
            id: "anthropic/claude-opus-4.1",
            name: "Claude Opus 4.1",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "openai/gpt-5-nano": {
            id: "openai/gpt-5-nano",
            name: "GPT-5 Nano",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10-01",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.05,
                output: 0.4,
                cache_read: 0.005,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/gpt-4.1": {
            id: "openai/gpt-4.1",
            name: "GPT-4.1",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 8,
                cache_read: 0.5,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "openai/gpt-oss-20b": {
            id: "openai/gpt-oss-20b",
            name: "GPT OSS 20B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.05,
                output: 0.2,
            },
            limit: {
                context: 131072,
                output: 65536,
            },
        },
        "openai/gpt-5": {
            id: "openai/gpt-5",
            name: "GPT-5",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10-01",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.125,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/gpt-5-mini": {
            id: "openai/gpt-5-mini",
            name: "GPT-5 Mini",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10-01",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.25,
                output: 2,
                cache_read: 0.025,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/gpt-oss-120b": {
            id: "openai/gpt-oss-120b",
            name: "GPT OSS 120B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.6,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "x-ai/grok-4": {
            id: "x-ai/grok-4",
            name: "Grok 4",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-07",
            release_date: "2025-07-09",
            last_updated: "2025-07-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.75,
                cache_write: 15,
            },
            limit: {
                context: 256000,
                output: 64000,
            },
        },
        "google/gemini-2.5-pro": {
            id: "google/gemini-2.5-pro",
            name: "Gemini 2.5 Pro",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-06-17",
            last_updated: "2025-06-17",
            modalities: {
                input: ["text", "image", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.31,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "google/gemini-2.5-flash": {
            id: "google/gemini-2.5-flash",
            name: "Gemini 2.5 Flash",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-06-17",
            last_updated: "2025-06-17",
            modalities: {
                input: ["text", "image", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 2.5,
                cache_read: 0.0375,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "qwen/qwen3-coder": {
            id: "qwen/qwen3-coder",
            name: "Qwen3 Coder",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.3,
                output: 1.2,
            },
            limit: {
                context: 262144,
                output: 66536,
            },
        },
        "moonshotai/kimi-k2": {
            id: "moonshotai/kimi-k2",
            name: "Kimi K2",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-11",
            last_updated: "2025-07-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.55,
                output: 2.2,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
    },
};
export default fastrouterModels;
//# sourceMappingURL=fastrouter.js.map